module.exports = __webpack_public_path__ + "media/futuristic.4296915e.wav";